export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["мин"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купить"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["за"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активно"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ссылка на объявление"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID мейкера"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Описание"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Таймаут"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата создания"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Я заплачу"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Я получу"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Лимит сделки"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Все"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сделки"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID предложения"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курс"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите счет"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не попадает в лимит"])}
}